import React, { Component } from "react";
import '../Styles/ProjectHome.css';
import CarouselImage from "./CarouselImage";

export default class ProjectHome extends Component {
  render() {

    const { project, recipesApp } = this.props;

    return (
      <section className="project-details">
        { project &&
          <>
            <div
              className="details-buttons"
              data-aos="fade-down"
              data-aos-duration="1700"
            >

              {
                project.links.app && (
                  <a target="_blank" href={ project.links.app } rel="noreferrer">
                    Aplicação
                  </a>
                )
              }

              {
                project.links.swagger && (
                  <a target="_blank" href={ project.links.swagger } rel="noreferrer">
                    Swagger
                  </a>
                )
              }

              <a target="_blank" href={ project.links.repo } rel="noreferrer">
                Repositório
              </a>
            </div>

            <div className="details-description">
              <h1 className="title-project-details">O que foi desenvolvido?</h1>
              <div className="project-details-description">
                { project.development }
              </div>
              { project.type === 'backend' && <h1 className="title-project-details">Desafios e aprendizados</h1> }
              <div className="project-details-description">
                { project.challenges }
              </div>
            </div>

            {
              project.type === "frontend" && (
                <div className="demonstration">
                  <h1 className="title-project-details">Demonstração</h1>
                  <div className="demonstration-video">
                    <video
                      src={ project.demonstration.video }
                      autobuffer="true"
                      controls
                      width="85%"
                    />
                  </div>
  
                  <h1 className="title-project-details">Screenshots</h1>
                  <div className="demonstration-screenshot">
                    <CarouselImage imageList={ project.demonstration.screenshots } recipesApp={ recipesApp } />
                  </div>
                </div>
              )
            }

          </>
        }
      </section>
    )
  }
}